/**
 * Utility functions for offline queue operations
 */

/**
 * Deep copy an object for serialization purposes.
 * Uses JSON serialization which is fast and appropriate for data that will be persisted.
 *
 * Note: This method will not preserve:
 * - Functions
 * - Undefined values
 * - Symbols
 * - Dates (converted to strings)
 * - RegExp (converted to objects)
 * - Circular references (will throw error)
 *
 * This is acceptable for our use case as we're serializing GraphQL variables
 * and metadata which should only contain plain data structures.
 *
 * @param {*} value - The value to deep copy
 * @returns {*} A deep copy of the value
 */
export const deepCopy = (value) => {
	if (value === null || value === undefined) {
		return value;
	}

	try {
		return JSON.parse(JSON.stringify(value));
	}
	catch (error) {
		// Fallback for circular references or other JSON serialization errors
		console.error('[OfflineQueue] Deep copy failed, returning original value:', error);
		return value;
	}
};
